import Ball from '@components/ball';
import {
    disindicate_touch,
    indicate_touch,
    touches_to_be_indicated,
} from './state';
import { defineComponent, h } from 'vue';
import { px, rem } from '@phi/util/css';
import { utility } from '@phi/components';

export const TouchIndicator = defineComponent({
    mounted() {
        document.addEventListener('pointerdown', indicate_touch);
        document.addEventListener('pointermove', indicate_touch);
        document.addEventListener('pointerup', disindicate_touch);
        document.addEventListener('pointercancel', disindicate_touch);
    },

    unmounted() {
        document.removeEventListener('pointerdown', indicate_touch);
        document.removeEventListener('pointermove', indicate_touch);
        document.removeEventListener('pointerup', disindicate_touch);
        document.removeEventListener('pointercancel', disindicate_touch);
    },

    render() {
        return h('div', { class: 'touch-indicator' },
            touches_to_be_indicated.map(x => h(Ball, {
                class: [
                    utility.absolute,
                    utility.z_maximum,
                    utility.transform_center,
                ],
                style: {
                    top: px(x.y),
                    left: px(x.x),
                },
                diameter: rem(2),
                color: 'var(--brand-t2)',
            })));
    },
});
